const currencies = {
  "PKR": true,
  "USD": true,
  "GBP": true,
  "CAD": true,
  "CNY": true
}

exports.currencies = currencies